import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";
import Attachment from "../../assets/images/expert/attachment.png";
import PendingUpdates from "../../assets/images/expert/pending-tasks.png";
import Timeline from "../../assets/images/expert/timeline.png";
import TooltipIcons from "../../atoms/project-card-footer-icons";
import { AppRoutes } from "../../constants/app-routes";
import { isExpert } from "../../utils/role";
import "./expert-profile-sidebar.scss";

const ExpertProfileSidebar = (props: any) => {
  const is_expert = isExpert();

  return (
    <Grid className="sidebar-btns" item xs={12} md={9} lg={8} xl={6}>
      <TooltipIcons
        icon={Attachment}
        isIcon={true}
        title="Attachment"
        handleClick={props.toggleAttachment}
      />
      {!is_expert && (
        <TooltipIcons
          icon={Timeline}
          isIcon={true}
          title="Timeline"
          handleClick={props.toggleTimeline}
        />
      )}

      <Link
        to={`${AppRoutes.EXPERT_PENDING_APPROVAL}?id=${props.id}`}
        target="_blank"
        rel="noreferrer,noopener"
      >
        <>
          <TooltipIcons
            icon={PendingUpdates}
            title="Pending Edits"
            isIcon={true}
          />
          {props.pending_edits ? (
            <p
              style={{
                position: "absolute",
                top: "-5px",
                right: "-5px",
                color: "white",
                backgroundColor: "#ec9324",
                fontSize: "11px",
                fontWeight: "500",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "22px",
                height: "22px",
                borderRadius: "100%",
              }}
            >
              {props.pending_edits || 0}
            </p>
          ) : null}
        </>
      </Link>

      {/* <TooltipIcons
        icon={Timeline2}
        isIcon={true}
        title="Timeline"
        handleClick={props.toggleTimeline}
      /> */}
    </Grid>
  );
};
export default ExpertProfileSidebar;
